import { ONE_SECOND } from '@air/utilities';

export const ONBOARDING_INTRO_IMAGE_DIR = '/assets/images/onboarding-intro';

const ONBOARDING_INTRO_LOTTIE_FPS = 60;

/**
 * Last frame of the `AirLogo` Lottie. The composition's `op` is 181 (exclusive), so this is the
 * settled wordmark a reduced-motion visitor should see instead of the draw.
 */
export const ONBOARDING_INTRO_BRAND_LOTTIE_END_FRAME = 180;

/**
 * The logo animation is authored at 60fps / 181 frames (~3s). At 1× the stroke is over before it can be
 * watched; this multiplies Lottie's clock so the write matches the mock's pace.
 */
export const ONBOARDING_INTRO_BRAND_LOTTIE_SPEED = 0.6;

/** Wall-clock play time for the logo draw at {@link ONBOARDING_INTRO_BRAND_LOTTIE_SPEED}. */
export const ONBOARDING_INTRO_BRAND_LOTTIE_PLAY_DURATION_MS = Math.ceil(
  (ONBOARDING_INTRO_BRAND_LOTTIE_END_FRAME / ONBOARDING_INTRO_LOTTIE_FPS / ONBOARDING_INTRO_BRAND_LOTTIE_SPEED) *
    ONE_SECOND,
);

/**
 * Beat before the tagline starts. Long enough that the Air stroke is already a shape, so the two
 * marks are not drawing over each other.
 */
export const ONBOARDING_INTRO_BRAND_BODY_DELAY_S = 1.2;

/**
 * Last frame of `AirTagline`. The composition's `op` is 81 (exclusive) at 60fps, so this is the
 * settled line a reduced-motion visitor sees instead of the write.
 */
export const ONBOARDING_INTRO_TAGLINE_LOTTIE_END_FRAME = 80;

/** Wall-clock time from welcome mount through tagline delay and draw at 1× Lottie speed. */
export const ONBOARDING_INTRO_TAGLINE_LOTTIE_PLAY_DURATION_MS = Math.ceil(
  ONBOARDING_INTRO_BRAND_BODY_DELAY_S * ONE_SECOND +
    (ONBOARDING_INTRO_TAGLINE_LOTTIE_END_FRAME / ONBOARDING_INTRO_LOTTIE_FPS) * ONE_SECOND,
);

/** The prototype's logo flight from the centred welcome up to the top of the sky. */
export const ONBOARDING_INTRO_FLIGHT_S = 0.72;

/**
 * Stills behind the wordmark when this step is not yet reading the workspace library. The ribbon
 * spends the whole list once. These live in `public/` so they are stable URLs, not webpack hashes.
 */
export const ONBOARDING_INTRO_FALLBACK_SRCS = [
  `${ONBOARDING_INTRO_IMAGE_DIR}/library-cap-lift.jpg`,
  `${ONBOARDING_INTRO_IMAGE_DIR}/library-jar-portrait.jpg`,
  `${ONBOARDING_INTRO_IMAGE_DIR}/library-wordmark-face.jpg`,
  `${ONBOARDING_INTRO_IMAGE_DIR}/library-cheek-tube.jpg`,
  `${ONBOARDING_INTRO_IMAGE_DIR}/library-flatlay.jpg`,
  `${ONBOARDING_INTRO_IMAGE_DIR}/library-contact-sheet.jpg`,
  `${ONBOARDING_INTRO_IMAGE_DIR}/library-palette.jpg`,
  `${ONBOARDING_INTRO_IMAGE_DIR}/library-tube-nozzle.jpg`,
  `${ONBOARDING_INTRO_IMAGE_DIR}/library-perfume-bottle.jpg`,
  `${ONBOARDING_INTRO_IMAGE_DIR}/library-pink-tube.jpg`,
  `${ONBOARDING_INTRO_IMAGE_DIR}/library-orange-bottle.jpg`,
  `${ONBOARDING_INTRO_IMAGE_DIR}/library-perfume-silhouette.jpg`,
] as const;
